<template>
  <div class="third_login_container">
    <img src="@/assets/img/wait.gif" alt="" />
  </div>
</template>
<script>
import tokenJwt from "@/utils/token.js";
import store from '@/store'
export default{
  data(){
    return{

    }
  },
  methods:{

  },
  created(){
    tokenJwt.removeToken();
    tokenJwt.removeRefreshToken();
    this.$store.commit('SET_EXPRIED', 0);
    this.$store.commit('SET_NAME', '');
    this.$store.commit('SET_ID', '');
    this.$store.commit('SET_TYPE', '');
    this.$store.commit('SET_REFRESH_TOKEN', '');
    this.$store.commit('SET_TOKEN', '');
    this.$store.commit('SET_PERMISSION', '');
    localStorage.removeItem("store");
    localStorage.removeItem("permission");

    this.$store.dispatch("thirdlogin", {
      token: this.$route.query.ldpToken,
      screenUrl: this.$route.query.screenUrl
    }).then((rsp) => {
      if(!rsp){
        this.$router.push({ path: "/noUser" });
        return
      }
        this.loading = false;
          window.sessionStorage.setItem('organCode',rsp.data.user.organCode||'')
          //定时刷新token
          setInterval((_) => {
            this.$store.dispatch("refreshToken");
          }, 1140 * 1000);
          this.$router.push({ path: "/" });
      })
  }
}
</script>
<style scoped>
.third_login_container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  caret-color: transparent;
}
</style>